module.exports = __webpack_public_path__ + "img/47.e47008de.jpg";